const excludeKeyList = ['_id', 'formType'];
const isDate = date => !Number.isNaN(new Date(date).getDate());

// eslint-disable-next-line import/prefer-default-export
export const transformObjectValuesToUpperCase = obj => {
    // eslint-disable-next-line no-restricted-syntax
    for (const k of Object.keys(obj)) {
        if(! excludeKeyList.includes(k)) {
            if (typeof obj[k] === 'string' && ! isDate(obj[k])) {
                // eslint-disable-next-line no-param-reassign
                obj[k] = obj[k].toUpperCase();
            }
            else if(Array.isArray(obj[k])) {
                obj[k].forEach(data => {
                    // eslint-disable-next-line no-restricted-syntax
                    for (const key of Object.keys(data)) {
                        if (typeof data[key] === 'string' && ! isDate(data[key])) {
                            // eslint-disable-next-line no-param-reassign
                            data[key] = data[key].toUpperCase();
                        }
                    }
                });
            }
        }
    }
    return obj;
};